import React, { useEffect, useState } from 'react';
import {
  Box, AppBar, Toolbar, Grid, Stack, InputAdornment,
  Avatar, CircularProgress, TextField, Button, IconButton
} from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Visibility } from '@mui/icons-material';
import { VisibilityOff } from '@mui/icons-material';
import whitelogo from '../images/rcor_logo.png'
import { Link, useNavigate } from 'react-router-dom';

function Login() {
    const navigate = useNavigate();
    const [username, setusername] = useState("");
    const [password, setpassword] = useState("");
    const users = [
      { username: "admin", password: "admin123", role: "admin" },
      { username: "mechanic", password: "mechanic123", role: "mechanic" },
    ];
  
    const handleSubmit = (e) => {
      e.preventDefault();
      const account = users.find((user) => user.username === username);
      if (account && account.password === password) {

        localStorage.setItem("authenticated", true);
  
        // Determine where to redirect based on the user's role
        if (account.role === "admin") {
          navigate("/home");
        } else {
          navigate("/mechanic");
        }
      }
    };
  return (
    <>
        <Box>
          <AppBar position="fixed" sx={{ backgroundColor: '#404040', height: '55px' }}>
            <Toolbar>
              <Link to='https://www.rcor.co/'><img src={whitelogo} alt='logo' /></Link>

            </Toolbar>
          </AppBar>
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4}>
              </Grid>
              <Grid item xs={12} sm={12} md={4} >
                <Box sx={{
                  my: 15,
                  mx: 4,
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  backgroundColor: 'white',
                  borderRadius: '20px',
                }}>
                  <Avatar sx={{ m: 1, bgcolor: '#404040' }}>
                    <LockOutlinedIcon />
                  </Avatar>
                  <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#404040' }}>WAVES</span>
                  <span style={{ fontWeight: 'bold', fontSize: '13px', color: '#404040' }}>Garage Management System</span>
                  {/* {errMsg && <span style={{ color: 'red' }}>{errMsg}</span>}
                  {isValid && <Box sx={{ textAlign: 'center', marginTop: '20px' }}>
                    <CircularProgress />
                  </Box>} */}
                  <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 5 }}>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="Username"
                      name="email"
                      autoComplete="email"
                      autoFocus
                      value={username}
                      onChange={(e) => { setusername(e.target.value) }}
                    />
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      name="password"
                      label="Password"
                    type='password'                      
                    id="password"
                      autoComplete="current-password"    
                      value={password}
                      onChange={(e) => { setpassword(e.target.value)}}
                    />
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 3, mb: 2, backgroundColor: '#404040', color: 'white' }}
                    >
                      Log In
                    </Button>

                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
              </Grid>
            </Grid>
          </Box>
          <AppBar position="fixed" color="primary" sx={{ top: 'auto', bottom: 0, backgroundColor: '#404040' }}>
            <Box p='10px' display='flex' justifyContent='center'>
              <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 1 }}>
                <span>RCOR Technologies Pvt Ltd., Calvary Road, Thrissur - 4,</span>
                <span>Contact : analyzesupport@rcor.co  |  9495420950</span>
              </Stack>
            </Box>
          </AppBar>
        </Box>
    </>
  )
}

export default Login